import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGetCustomerSummaryResponse } from "../../../models/user/InsureAssist/InsureAssist";
import { GetInitBasePrompt } from "../../../customers/Dashboard/DashboardAction";

interface InsureAssistState {
  initResponse: string | null;
}

const initialState: InsureAssistState = {
  initResponse: sessionStorage.getItem('insureAssistInitResponse') || null,
};

const insureAssistSlice = createSlice({
  name: "insureAssist",
  initialState: initialState,
  reducers: {
    setInitResponse(state, action: PayloadAction<IGetCustomerSummaryResponse>) {
      const initResponse = action.payload.data.split("::")[1];
      state.initResponse = initResponse;
      // Store in sessionStorage
      sessionStorage.setItem('insureAssistInitResponse', initResponse);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      GetInitBasePrompt.fulfilled,
      (state, action: PayloadAction<IGetCustomerSummaryResponse>) => {
        const initResponse = action.payload &&
          action.payload.status === "SUCCESS" &&
          action.payload.data
            ? action.payload.data.split("::")[1]
            : null;
        
        state.initResponse = initResponse;
        // Store in sessionStorage
        if (initResponse) {
          sessionStorage.setItem('insureAssistInitResponse', initResponse);
        }
      }
    );
  },
});

export const { setInitResponse } = insureAssistSlice.actions;
export default insureAssistSlice.reducer;
